<div class="create-message-container">

  <!-- BACK -->
  <div class="navigation" (click)="navigateToMessagesPage()">
    <img class="image-back" src="assets/images/back.png" alt="Back">
    <span class="label-back">Back to Messages</span>
  </div>

  <div class="title-box">
    <span class="title-section">{{ isEditMode ? 'Edit Message' : 'Create New Message' }}</span>
  </div>

  <div class="content">

    <!-- LEFT PANEL -->
    <div class="left-panel" >

      <form [formGroup]="_formGroupCreateMessage">
        <!-- Message Name Input -->
        <div class="form-group">
          <label for="messageName" class="input-label">Message Name</label>
          <input mdbInput type="text" maxlength="225" id="messageName" class="form-control input-style"
            placeholder="Enter Message Name" formControlName="messageName">
        </div>

        <!-- Folder Select -->
        <div class="form-group">
          <label for="messageFolder" class="input-label">Folder</label>
          <select class="form-control select-input" name="messageFolder" id="messageFolder"
            formControlName="messageFolder">
            <option value="0" hidden>Select Folder</option>
            <option *ngFor="let folder of _messageFolderSelectListOptions; let i = index"
              [ngValue]="folder.value">
              {{folder.label}}
            </option>
          </select>
        </div>
      </form>

      <h3 class="panel-title">Message Type</h3>

      <div class="type-card" *ngIf="isInternalUser && _hasClientAnyRcsApp"
        [class.active]="selectedType === 'rcs'"
        [class.disabled]="!_formGroupCreateMessage.valid || isEditMode"
        (click)="!isEditMode && selectType('rcs')"
        [style.pointer-events]="(!_formGroupCreateMessage.valid || isEditMode) ? 'none' : 'auto'"
        [style.opacity]="(!_formGroupCreateMessage.valid || isEditMode) ? '0.5' : '1'">
        <img src="assets/images/Icons/rcs.png">
        <h4>RCS</h4>
        <p>Rich messages with multimedia</p>
      </div>

      <div class="type-card"
        [class.active]="selectedType === 'sms'"
        [class.disabled]="!_formGroupCreateMessage.valid || isEditMode"
        (click)="!isEditMode && selectType('sms')"
        [style.pointer-events]="(!_formGroupCreateMessage.valid || isEditMode) ? 'none' : 'auto'"
        [style.opacity]="(!_formGroupCreateMessage.valid || isEditMode) ? '0.5' : '1'">
        <img src="assets/images/Icons/sms.png">
        <h4>SMS</h4>
        <p>Simple text message</p>
      </div>

      <div *ngIf="selectedType === 'rcs'" class="sub-header">Notification Type</div>

      <div *ngIf="selectedType === 'rcs'" class="sub-cards-grid">
        <div class="sub-card" 
             [class.active]="selectedRcsType===MessageType.TEXT" 
             (click)="!isEditMode && selectRcsType(MessageType.TEXT)"
             [style.pointer-events]="isEditMode ? 'none' : 'auto'"
             [style.opacity]="isEditMode ? '0.5' : '1'">
          <img src="assets/images/Icons/text.png">
          <span>Text</span>
          <p>Basic message content</p>
        </div>
        <div class="sub-card" 
             [class.active]="selectedRcsType===MessageType.STANDALONE" 
             (click)="!isEditMode && selectRcsType(MessageType.STANDALONE)"
             [style.pointer-events]="isEditMode ? 'none' : 'auto'"
             [style.opacity]="isEditMode ? '0.5' : '1'">
          <img src="assets/images/Icons/richtext.png">
          <span>Rich Card</span>
          <p>Enhanced message with multimedia</p>
        </div>
        <div class="sub-card" 
             [class.active]="selectedRcsType===MessageType.CAROUSEL" 
             (click)="!isEditMode && selectRcsType(MessageType.CAROUSEL)"
             [style.pointer-events]="isEditMode ? 'none' : 'auto'"
             [style.opacity]="isEditMode ? '0.5' : '1'">
          <img src="assets/images/Icons/carousel.png">
          <span>Carousel</span>
          <p>Series of horizontally scrollable cards</p>
        </div>
      </div>

    </div>

    <!-- RIGHT DYNAMIC AREA -->
    <div class="right-panel">
      <ng-container *ngIf="selectedType === null || (selectedType === 'rcs' && !selectedRcsType)">
        <div class="placeholder">
          <img src="assets/images/Icons/megaphone.png">
          <p>Please select a message type</p>
        </div>
      </ng-container>

      <app-sms-message 
        *ngIf="selectedType === 'sms'"
        [messageName]="_formGroupCreateMessage.get('messageName').value"
        [selectedFolderId]="_selectedMessageFolderId">
      </app-sms-message>
      
      <!-- Create message-builder once and keep it alive -->
      <app-message-builder 
        *ngIf="selectedType === 'rcs'"
        [style.display]="!selectedRcsType ? 'none' : 'block'"
        [initialType]="selectedRcsType"
        [messageName]="_formGroupCreateMessage.get('messageName').value"
        [selectedFolderId]="_selectedMessageFolderId"
        [isEditMode]="isEditMode"
        [messageId]="messageId"
        [messageData]="currentEditMessage">
      </app-message-builder>
    </div>

  </div>
</div>